import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { BulletinType } from 'constants/enums/bulletinType.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Home } from 'constants/models/components/home';
import { Inscats, Recommands, Activities, Codes, Bulletin, Activity, RecommandData, Recommand } from 'bff/models/info';
import { BaseRes } from 'bff/models/base/baseRes';
import { Service, Links } from 'bff/models/link';
import _ from 'lodash';
// import { InsType } from 'constants/enums/insType.enum';

/**
 * @description 取得首頁初始化資料
 */
const fetchInitSetting = async ():Promise<Home> => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchInscat(baseReq, reqConfig),
    apiService.fetchRecommands(baseReq, reqConfig),
    apiService.fetchActivities(baseReq, reqConfig),
    // apiService.fetchActivitiesByInsTypeId(baseReq, reqConfig, InsType.Travel),
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.Service),
    apiService.fetchAnnounces(baseReq, reqConfig, BulletinType.Default),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([inscatRes, recommandsRes, activitiesRes, serviceLinksRes, announceRes, codeTablesRes]) => {
    const inscatBaseRes:BaseRes<Inscats> = { ...inscatRes };
    const recommandsBaseRes:BaseRes<Recommands> = { ...recommandsRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const serviceLinksBaseRes:BaseRes<Links<Service>> = { ...serviceLinksRes };
    const announceBaseRes:BaseRes<Bulletin> = { ...announceRes };
    const codeTablesBaseRes:BaseRes<Codes> = { ...codeTablesRes };

    const res:Home = {
      inscats: commonService.arrayTypeReturn(inscatBaseRes.TRANRS.INSURANCE_CATEGORY),
      recommands: recommandsBaseRes.TRANRS.RECOMMANDS ? _.forEach(recommandsBaseRes.TRANRS.RECOMMANDS, (recommandData:RecommandData) => {
        return recommandData.RECOMMAND.sort((first:Recommand, second:Recommand) => first.SHOW_ORDER - second.SHOW_ORDER);
      }) : new Array(0),
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      },
      serviceLinks: commonService.arrayTypeReturn(serviceLinksBaseRes.TRANRS.LINKS?.SERVICE),
      bulletin: announceBaseRes.TRANRS.BULLETIN ? { ...announceBaseRes.TRANRS } : { BULLETIN: {} } as Bulletin,
      codeTables: commonService.arrayTypeReturn(codeTablesBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
